import { AppBar, Grid, IconButton, makeStyles, Toolbar, Typography } from '@material-ui/core'
import MROFullScreenRightDrawer from 'components/fullwidth_dialog'
import React from 'react'
import BackIcon from "@material-ui/icons/KeyboardBackspace";


const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: "#fff",
        color: "#000000CC",
        boxShadow: "0px 3px 6px #0000001A",
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    root: {
        backgroundColor: "#ffffff",
    },
    wrapper: {
        padding: "0 24px",
    },

}));

export default function ToolBar(props) {
    const classes = useStyles()
    const { handleClose, titleName } = props

    return (

        <>
            <AppBar position="static" className={classes.appBar} elevation={0}>
                <Toolbar>
                    <Grid container>
                        <Grid item xs={11} container>
                            <IconButton
                                onClick={handleClose}
                                edge="start"
                                className={classes.backButton}
                                color="inherit"
                                aria-label="back"
                            >
                                <BackIcon />
                            </IconButton>
                            <Typography style={{ fontSize: "15px", marginTop: "5px" }} variant="subtitle2">
                                {titleName}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            {props.children && props.children}
                        </Grid>
                    </Grid>
                </Toolbar>

            </AppBar>

        </>



    )
}
